import { Form, Input, Button } from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { useAuthWrapper } from '_helpers';
export { PasswordRecover };

function PasswordRecover() {
    const authWrapper = useAuthWrapper();
    const [submitting, setSubmitting] = useState(false);

    const onFinish = async (values) => {
        setSubmitting(true);
        await authWrapper.forgetPassword(values);
        setSubmitting(false);
    };

    return (
        <div className="account-screen">
            <div className="account-card">
                <h4 style={{ marginBottom: 24 }}>Khôi phục tài khoản</h4>
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        label="Vui lòng nhập email đã đăng ký với tài khoản của bạn"
                        name="email"
                        rules={[{ required: true, message: 'Vui lòng nhập email' }]}
                    >
                        <Input size="large" type="email" />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type="primary" htmlType="submit" loading={submitting} size="large">
                            Khôi phục
                        </Button>
                        <Link to="login" style={{ marginLeft: 16 }}>Quay lại</Link>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
